import { render, staticRenderFns } from "./TifLiquidacionesFirmas.vue?vue&type=template&id=b8ef5a5e"
import script from "./TifLiquidacionesFirmas.vue?vue&type=script&lang=js"
export * from "./TifLiquidacionesFirmas.vue?vue&type=script&lang=js"
import style0 from "./TifLiquidacionesFirmas.vue?vue&type=style&index=0&id=b8ef5a5e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports